export default "__VITE_ASSET__Cpuqtw0J__"